import AppRoot from "./AppRoot.vue";
import Sidebar from "./sidebar/Sidebar";
import Navbar from "./sidebar/Navbar";
import HpoList from "./hpo/HpoList";
import HpoDashboard from "./hpo/dashboard/HpoDashboard";
import Index from "./index/Index";
import DeviceManage from "./device/DeviceManage.vue";
import DeviceAuthSuccessPage from "./device/auth/DeviceAuthSuccessPage.vue";
import DeviceAuthCompletePage from "./device/auth/DeviceAuthCompletePage.vue";
import DeviceLoginPage from "./device/login/DeviceLoginPage.vue";

export const components = {
    AppRoot,
    Sidebar,
    Navbar,
    HpoList,
    HpoDashboard,
    Index,
    DeviceManage,
    DeviceAuthSuccessPage,
    DeviceAuthCompletePage,
    DeviceLoginPage,
}